import { render, staticRenderFns } from "./CtcSimilarProductCards.vue?vue&type=template&id=32b5b08e&scoped=true&"
import script from "./CtcSimilarProductCards.vue?vue&type=script&lang=js&"
export * from "./CtcSimilarProductCards.vue?vue&type=script&lang=js&"
import style0 from "./CtcSimilarProductCards.vue?vue&type=style&index=0&id=32b5b08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5b08e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
